import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const complianceChatPage = PageBlueprint.make({
  params: {
    path: '/compliance-chat',
    noHeader: true,
    loader: () =>
      import('./components/ComplianceChatPage').then(m => (
        <PageErrorBoundary title="Compliance chat">
          <m.ComplianceChatPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-compliance-chat',
  extensions: [complianceChatPage],
});
